import ShareableLinkContent from './ShareableLinkContent.component';

export default ShareableLinkContent;
